import { render, staticRenderFns } from "./ConsultarModificacion.vue?vue&type=template&id=4910b532"
import script from "./ConsultarModificacion.vue?vue&type=script&lang=js"
export * from "./ConsultarModificacion.vue?vue&type=script&lang=js"
import style0 from "./ConsultarModificacion.vue?vue&type=style&index=0&id=4910b532&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports